export default __webpack_public_path__ + "static/media/logentries.295ddc2d.svg";